import {
  Box,
  Text,Tabs, TabList, Tab, TabPanels, TabPanel 
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedMenu, setHeaderText } from "../../redux/actions/actions";
import { loadReports,loadTutorSubjects } from "../../redux/api_calls/apiCalls";
import ItemsList from "./ItemsList";
import { useHistory } from "react-router-dom";

// import exportFromJSON from 'export-from-json'

export default function Reports() {
    // const [isLoading, setIsLoading] = useState(false)
    const headerText = useSelector(state => state.headerState.headerText)
    const { reportsData } = useSelector(state => state.reportsState)
    const { TutorSubjectsList } = useSelector(state => state.TutorSubjectsList)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    const [coursesList, setCoursesList] = useState([])
    const [subjectList, setSubjectsList] = useState([])
    const history = useHistory();
    useEffect(() => {
        dispatch(setHeaderText('Analytics'))
        dispatch(selectedMenu(8))
        if (!reportsData) {
            dispatch(loadReports())
        }
       
        if (!TutorSubjectsList) {
            dispatch(loadTutorSubjects())
        }
        // eslint-disable-next-line
    }, [dispatch])

    useEffect(() => {
        if (reportsData) {
            setCoursesList(reportsData)
        }
    }, [reportsData])

   
    useEffect(() => {
        if (TutorSubjectsList) {
            console.log(TutorSubjectsList, "TutorSubjectsList")
            setSubjectsList(TutorSubjectsList)
        }
    }, [TutorSubjectsList])

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                w='80%'
                mb='3rem'
            >
                <Box
                    w='100%'
                    d='flex'
                    flexDir='column'
                >

            <Tabs width={['100%']} variant='unstyled' colorScheme='blue'>
                    <TabList style={{ border: 'none' }}>
                        <Tab width="50%"  _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px',fontFamily: 'Mulish, sans-serif' }}>Stats</Tab>
                        <Tab width="50%"  _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px',fontFamily: 'Mulish, sans-serif' }}>Subjects</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel padding="0">
                        <Box
                            d='flex'
                            justifyContent='space-between'
                            alignItems='flex-start'
                            w='100%'
                            mb='3rem'
                        >
                            <Box
                                w='100%'
                                d='flex'
                                flexDir='column'
                            >
                                <Text
                                    fontSize='15px'
                                    color='#222222'
                                    fontWeight='800'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    mb='1rem'
                                >
                                </Text>
                                
                                    <ItemsList statistics={coursesList} />
                                
                            </Box>


                        </Box>
                        </TabPanel>
                       
                        <TabPanel padding="0">
                            <Box
                            w='100%'
                            alignItems='center'
                            px='1rem'
                            
                            mb='1rem' >
                            <Box
                                w='100%'
                                d='flex'
                                flexDir='column'
                            >
                                <Text
                                    fontSize='15px'
                                    color='#222222'
                                    fontWeight='800'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    mb='1rem'
                                >
                                </Text>
                                
                                    <Box
                                        w='100%'
                                        d='flex'
                                        justifyContent='space-around'
                                        alignItems='center'
                                        mb='3rem'
                                        px='1rem'

                                    >
                                        <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%'>S.No</Text>
                                        <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>Subject Name</Text>                
                                    </Box>
                                    <Box  
                                    border='1px solid rgba(0, 0, 0, 0.1)'
                                    boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
                                    borderRadius='10px'
                                    bgColor='white'
                                    width  ='100%'
                                    >
                                       {
                                        Object.keys(subjectList).map((keyName, keyIndex) => <Box
                                            w='100%'
                                            d='flex'
                                            justifyContent='space-around'
                                            alignItems='center'
                                            py='1rem'
                                            fontSize='15px'
                                            color='#000000'
                                            fontWeight='600'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                                            key={keyIndex}
                                            cursor="pointer" onClick={() => history.push("/reports/subjects/" + subjectList[keyName]['id'])}

                                        >
                                            <Text width='12%' cursor="pointer" onClick={() => history.push("/reports/subjects/" + subjectList[keyName]['id'])}>{keyIndex+1}</Text>
                                            <Text width='14.5%' textAlign='center'>{subjectList[keyName]['name']}</Text>
                                                                </Box>
                                        )
                                    }
                                </Box>
                            </Box>


                        </Box>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </Box>
    </Box>
    )
}